import {RegexHelper} from '~/helpers/regexHelper'
import RegexValidator from './regexValidator'
import {Logger} from "~/services/logger"

export default class PresenceValidator<R> extends RegexValidator<R> {
  matcher: RegExp = RegexHelper.presence // non-blank && non-empty

  /**
   * Works for strings and arrays
   * Arrays are converted using +.toString()+ in the +RegExp.test+ function where an empty array evaluates to an empty string
   *
   * @param value
   * @protected
   */
  protected _validate(value: string | Array<string>): void {
    try {
      this.isValid = this.test(value.toString())
    } catch (e) {
      this.isValid = false
    }
    Logger.debug('Validator', 'PresenceValidator#validate', `isValid: ${this.isValid}`, `value: ${value}`)
    if (this.isValid) {
      this.errorMessage = ''
    } else {
      this.errorMessage = this.validationMessage || this.buildMessage({ suffix: 'a value' })
    }
  }
}